module.exports = __webpack_public_path__ + "static/media/Tiger599_2c.bb80823e.svg";